import { IAssunto } from './../modelo/Assunto';
import config from '../misc/Configuracao';
import fetch from './AxiosAdapter';

class AssuntoApi {

    async buscarPorProcessos(idsProcesso: number[], silent: boolean = false): Promise<IAssunto[][]> {
        if (idsProcesso.length) {
            const result = await fetch<IAssunto[][]>(`${config.urlProcessosGE}todos/assuntos`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                silent,
                data: idsProcesso
            });
            return result.data;
        }
        return [];
    }
}

export default new AssuntoApi();